import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>Route is not found</h1>
        </div>
    );
};

export default NoMatch;